module.exports = __webpack_public_path__ + "img/CG1_12.a2363d6.png";